
  import Vue from "vue"
  import OrderList from "@/components/OrderList.vue"
  
  export default Vue.extend({
    components: {
        OrderList
    },
    created() {
        document.title = this.$vuetify.lang.t("$vuetify.tab_titles.order_list")
    }
  })
  